import { createSelector } from '@reduxjs/toolkit'
import { hasModalDialog as hasMessagesDialog } from 'continuity/messages/subs'

export const hasModalDialog = createSelector(
  hasMessagesDialog,
  (hasMessagesDialog) => hasMessagesDialog
)
